module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_sandviken-671e9603aedde1733bebfbdeb8b4df7c.png";